<div class="errorPage">
  <div class="errorPage__container">
    <div class="errorPage__code">
      <h1>{{ errorCode }}</h1>
    </div>
    <h2 class="errorPage__message">{{ errorMessage }}</h2>
    <a mat-flat-button color="primary" class="errorPage__homeButton" [routerLink]="['/']">Go Back</a>
  </div>
</div>
